// Låter styckpris-parentesen "(104,98 kr/st)" följa pristrappan.
//
// Servern skickar färdig HTML per trappsteg i data-lw-unit-tiers och ordinarie
// styckpris i data-lw-unit-base (se helpers/lw_unit_price.php). Ingen
// prisformatering sker här — bara ett byte av innehåll efter kvantitet.
//
// Medvetet TILLSTÅNDSLÖST: allt läses från spanen vid varje anrop. På variabla
// produkter skapas spanen av variation-price.js vid found_variation, alltså
// efter att den här modulen initierats — en cachad "utgångspunkt" hade då blivit
// null och parentesen frusit på ordinarie pris.
//
// found_variation lyssnas delegerat på document. Det garanterar att vi kör
// EFTER variation-price.js, som binder direkt på formuläret (direkta handlers
// körs före delegerade när eventet bubblar).
(function () {
    function qty() {
        const input = document.querySelector('form.cart input[name="quantity"]')
        const value = input ? parseInt(input.value, 10) : 1
        return Number.isFinite(value) && value > 0 ? value : 1
    }

    function apply() {
        const span = document.querySelector('[data-lw-unit-price]')
        if (!span) return

        let tiers = []
        try {
            const parsed = JSON.parse(span.dataset.lwUnitTiers || '[]')
            if (Array.isArray(parsed)) tiers = parsed
        } catch (e) {
            // ignorera parse-fel — då står ordinarie styckpris kvar
        }

        const current = qty()
        const tier = tiers.find(function (t) {
            const max = t.max > 0 ? t.max : Infinity
            return current >= t.min && current <= max
        })

        const next = tier ? tier.inner : span.dataset.lwUnitBase || ''
        if (span.innerHTML !== next) span.innerHTML = next
    }

    function isQtyField(target) {
        return target && target.matches && target.matches('form.cart input[name="quantity"]')
    }

    function init() {
        apply()

        document.addEventListener('input', function (e) {
            if (isQtyField(e.target)) apply()
        })
        document.addEventListener('change', function (e) {
            if (isQtyField(e.target)) apply()
        })

        if (!window.jQuery) return
        window.jQuery(document).on('found_variation', 'form.variations_form', apply)
    }

    // Bundlen kan laddas både före och efter DOMContentLoaded — kör direkt om
    // dokumentet redan är parsat, annars vid eventet.
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init)
    } else {
        init()
    }
})()
